import { Fragment } from "react";
import Markdown from "react-markdown";
import AgentDetailsCard from "./agent-details-card";
import { parseAgentDetails } from "./utils";

import { LinkRenderer } from "./index";

export default ({ data }) => {
  const response = parseAgentDetails(data);
  if (response.type === "error") {
    return (
      <Markdown components={{ a: LinkRenderer }}>
        {response.error_message}
      </Markdown>
    );
  }

  const list = Object.values(response.response);
  let moreResultsAvailable = false;
  if (list.length > 2) {
    moreResultsAvailable = true;
    list.splice(2);
  }
  return (
    <div className="space-y-5 fa-list">
      {list.map((details, index) => (
        <Fragment>
          {index === 1 && <div className="h-0.5 bg-ejblack"></div>}
          <AgentDetailsCard {...details} />
        </Fragment>
      ))}
      {moreResultsAvailable && (
        <Markdown components={{ a: LinkRenderer }}>
          {response.post_message}
        </Markdown>
      )}
    </div>
  );
};
